import React, { useEffect, useState } from 'react';
import ProductHomePageSectionModel from './models/ProductHomePageSectionModel';

function DeleteProductHomePageSection({ SectionData }) {
  const [selected, setSelected] = useState(new ProductHomePageSectionModel());

  useEffect(() => {
    setSelected(SectionData || new ProductHomePageSectionModel());
  }, [SectionData]);

  return (
    <div>
      <p>Are you sure you want to delete this home page section?</p>
      <p><strong>{selected.SectionName}</strong></p>
    </div>
  );
}

export default DeleteProductHomePageSection;
